import {Component, Inject, Input} from '@angular/core';
import {SubTitle} from '../../models/hader-subtitle';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-header-subtitle',
  templateUrl: './header-subtitle.component.html',
  styleUrls: ['./header-subtitle.component.scss']
})
export class HeaderSubtitleComponent  {

  @Input() datas: SubTitle[];
  @Input() isAllowedRemove: SubTitle[];

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) { }


}
